// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3dQfY","footer":"ModalUpdate_footer__3nD1r"};